import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import jobsApi from '../../../APIs/jobs';
import {
  ReviewAndSend,
  TechnicianJobInformation,
} from '../../../components/TechnicianJobs';
import { Divider, NavigateBack } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { humanReadableDate, requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';

const JobDetails = () => {
  const params = useParams();
  const technicianJobsDetails = useSelector(
    (state: RootState) => state.technicianJobsDetails
  );
  const jobProcess = useSelector((state: RootState) => state.singleJobProcess);
  const { jobId, jobAndProposalId } = params;

  const fetchJobDetails = async (techJobId: string) => {
    await requestAPI(jobsApi.getTechnicianJobsDetails(techJobId));
  };

  const getJ0bProcess = async (id: string) => {
    try {
      await requestAPI(jobsApi.getJobProcessByJobProposal(id));
    } catch (err) {
      console.error('Error on fetching own uploaded data , ', err);
    }
  };

  useEffect(() => {
    if (jobId && jobAndProposalId) {
      fetchJobDetails(jobId);
      getJ0bProcess(jobAndProposalId);
    }
  }, [jobId, jobAndProposalId]);

  const formatLogosData = () => {
    const imgs = technicianJobsDetails?.logo?.map((img, idx) => ({
      id: `${idx + 1}`,
      URL: img,
    }));

    return imgs;
  };

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <ReviewAndSend jobAndProposalId={jobAndProposalId || ''} />
        <Divider spaceY="20px" />
        <TechnicianJobInformation
          jobDetails={{
            jobCreatedAt: humanReadableDate(
              technicianJobsDetails?.createdAt || 'yo mail etest '
            ),
            jobTitle: technicianJobsDetails?.jobTitle || '',
            notes: technicianJobsDetails?.notes || '',
            addressOfProperty:
              technicianJobsDetails?.building?.buildingAddress || '',
            buildingId: '1',
            buildingName: technicianJobsDetails?.building?.buildingName || '',
            jobCreatedByEmail:
              technicianJobsDetails?.createdBy?.emailAddress || '',
            jobCreatedByName: technicianJobsDetails?.createdBy?.fullName || '',
            blueprints: (technicianJobsDetails?.building?.bluePrints || []).map(
              (blueprint: { bluePrintUrl: string }, index: number) => ({
                id: index.toString(),
                URL: blueprint.bluePrintUrl || '',
              })
            ),
            shippingAddress: technicianJobsDetails?.shippingAddress,
            frameColor: technicianJobsDetails?.frameColor || '',
            jobCreatedByAvatar: '',
            materialTypeOfDrawing:
              technicianJobsDetails?.drawingMaterialType || '',
            resolutionOfLogo: technicianJobsDetails?.logoResolution || '',
            roundedEdge:
              technicianJobsDetails?.roundedEdge === true ? 'Yes' : 'No',
            sizeOfDrawing: technicianJobsDetails?.drawingSize || '',
            uploadedLogos: formatLogosData() || [],
            pdfReceatedCount: 3,
            additionalInfo: technicianJobsDetails.additionalRequirement || [],
            proposalSentAt:
              typeof jobProcess?.jobAndProposal?.acceptedProposal !== 'string'
                ? humanReadableDate(
                    jobProcess.jobAndProposal?.acceptedProposal?.createdAt
                  )
                : '',
            proposalAcceptedAt:
              typeof jobProcess?.jobAndProposal?.acceptedProposal !== 'string'
                ? humanReadableDate(
                    jobProcess.jobAndProposal?.acceptedProposal
                      ?.proposalStatusChangedDate?.[0].changeAt
                  )
                : '',
            contractGeneratedAt:
              typeof jobProcess.jobAndProposal?.contract !== 'string'
                ? humanReadableDate(
                    jobProcess.jobAndProposal?.contract?.createdAt
                  )
                : '',
            contractAcceptedAt:
              typeof jobProcess.jobAndProposal?.contract !== 'string'
                ? humanReadableDate(
                    jobProcess.jobAndProposal?.contract
                      .contractStatusChangedDate?.[0]?.changeAt
                  )
                : '',
          }}
        />
      </div>
    </ViewJobContainerStyled>
  );
};

export default JobDetails;
